import React from 'react';

export function ProjectHistoryModuleDistribution({ items }: { items: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <h3 className="text-sm font-normal text-slate-900 border-b border-slate-50 pb-2">Phân bổ theo phân hệ</h3>
      <div className="space-y-4">
        {items.map((item, idx) => (
          <div key={idx} className="space-y-1.5">
            <div className="flex justify-between text-xs font-normal">
               <span className="text-slate-600">{item.label}</span>
               <span className="text-slate-900">{item.count} ({item.percent}%)</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-50 overflow-hidden">
               <div className={`${item.color} h-full transition-all duration-700`} style={{ width: `${item.percent}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
